// Lib
import { useEffect } from 'react';

// Utils
import { hasMultipleAppRefreshesOccurred, throttleAndSendAnalyticsEventLastPersistedTime } from './multipleRefreshUtil';
import { setAppLocalCacheResetLocalStorage, setLastRefreshTimeLocalStorage } from './appLocalCacheStorageService';
import { shouldDisableLocalCacheReset } from '../debug/debugUtil';

// Constants
import { TIMES, getTimestamp } from '../../common/utils/timeUtil';

// This component handles a couple of things:
// 1. It checks if the user has refreshed the app multiple times in a short period of time (10 seconds).
// and if so, it sends an amplitude event to track this and also sets a local storage flag to indicate that the app cache should be reset.
// 2. It sets the last refresh time in local storage so that we can use that for other things related to instant app caching.
const AppMultipleRefreshHandler = (): null => {
    useEffect(() => {
        const appRefreshHandler = () => {
            if (hasMultipleAppRefreshesOccurred(TIMES.SECOND * 10) && !shouldDisableLocalCacheReset()) {
                throttleAndSendAnalyticsEventLastPersistedTime();
                setAppLocalCacheResetLocalStorage('true');
            }
            setLastRefreshTimeLocalStorage(getTimestamp().toString());
        };

        window.addEventListener('beforeunload', appRefreshHandler);

        return () => {
            window.removeEventListener('beforeunload', appRefreshHandler);
        };
    }, []);

    return null;
};

export default AppMultipleRefreshHandler;
